export interface StatusBadgeConfig {
    variant: "default" | "destructive" | "secondary"
    className?: string
    text: string
}

const statusBadgeMap: Record<string, StatusBadgeConfig> = {
    'Descartar': {
        variant: "destructive",
        text: "Descartar"
    },
    'Manter': {
        variant: "default",
        className: "bg-green-500",
        text: "Manter"
    }
}

export const getStatusBadgeConfig = (status: string): StatusBadgeConfig => {
    const normalizedStatus = status.toLowerCase()
    
    return statusBadgeMap[normalizedStatus] || {
        variant: "secondary",
        text: status
    }
}
